import React from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import Button from '../../../components/Button';
import Container from '@material-ui/core/Container';
import CreateProviderDialog from '../components/CreateProviderDialog';
import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  title: {
    marginBottom: '2rem',
  },
});

const ProviderAdminPage = ({history}) => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const classes = useStyles();

  const onProviderCreated = (uuid) => history.push(`/provider/${uuid}/admin/profile`);

  return (
    <Page title="Provider Admin">
      <SiteAdmin>
        <Typography variant="h6" color="primary" className={classes.title}>Provider Admin</Typography>
        <Container>
          <Button variant="outlined" color="primary" label="Create Organisation" onClick={()=>setCreateDialogOpen(true)}/>
        </Container>
      </SiteAdmin>
      <CreateProviderDialog open={createDialogOpen} setOpen={setCreateDialogOpen} onCreated={onProviderCreated}/>
    </Page>
  );
};

ProviderAdminPage.propTypes = {
  history: PropTypes.object.isRequired,
};


export default withAdminOnly(ProviderAdminPage);
